export type SupportedLocale = 'en' | 'zh' | 'fr' | 'es';

export type SupportedLocaleList = readonly SupportedLocale[];

export const SUPPORTED_LOCALES: SupportedLocaleList = ['en', 'zh', 'fr', 'es'];
